import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Register from '@/views/Register'
import Songs from '@/views/Songs'
import SongsView from '@/views/SongsView'
import SongsCatalog from '@/views/SongsCatalog'
import SongsPick from '@/views/SongsPick'
import Search from '@/views/Search'
import About from '@/views/About'
import Contact from '@/views/Contact'
import Hot from '@/views/Hot'
import Featured from '@/views/Featured'
import FeaturedPage from '@/views/FeaturedPage'
import Partner from '@/views/Partner'
import Collection from '@/views/Collection'
import Privacy from '@/views/Privacy'
import Topic from '@/views/Topic'
import TopicView from '@/views/TopicView'
import MainSearch from '@/views/MainSearch'

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'home',
  component: Home
}, {
  path: '/Login',
  component: Home,
  name: '登入'
}, {
  path: '/register',
  component: Register,
  name: '註冊',
  description: '註冊'
}, {
  path: '/privacy',
  component: Privacy,
  name: '隱私權政策',
  description: '隱私權政策'
}, {
  path: '/collection',
  component: Collection,
  name: '收藏歌曲',
  description: '收藏歌曲'
}, {
  path: '/about',
  component: About,
  name: '關於我們'
}, {
  path: '/hot',
  component: Hot,
  name: '熱門話題'
}, {
  path: '/songCategory/:id',
  component: Songs,
  name: '分類歌曲'
}, {
  path: '/featured',
  component: Featured,
  name: '頂上故事'
}, {
  path: '/featured/:id',
  component: FeaturedPage,
  name: '頂上故事內容'
}, {
  path: '/songsCatalog',
  component: SongsCatalog,
  name: '分類說明'
}, {
  path: '/songsPick',
  component: SongsPick,
  name: '挑歌秘訣'
}, {
  path: '/songs/:id',
  component: SongsView,
  name: '單篇歌曲'
}, {
  path: '/topic',
  component: Topic,
  name: '主題歌曲'
}, {
  path: '/topicview/:id',
  component: TopicView,
  name: '主題歌曲內容'
}, {
  path: '/search/:key',
  component: Search,
  name: 'search',
  beforeEnter: function (to, from, next) {
    console.log('Page search')
    next()
  }
}, {
  path: '/mainsearch/:key',
  component: MainSearch,
  name: 'mainsearch',
  beforeEnter: function (to, from, next) {
    console.log('Page mainSearch')
    next()
  }
}, {
  path: '/partner/:id',
  component: Partner,
  name: '相關夥伴'
}, {
  path: '/contact',
  component: Contact,
  name: '聯絡我們'
}]
export default routes



// WEBPACK FOOTER //
// ./src/router/index.js